import { GET_NATIONAL_OUTLOOK_BY_ID } from '../actions/nationalOutlookActions';

const initialState = {

};

export function nationalOutlook(state = initialState, action)
{
    switch (action.type)
    {
        case GET_NATIONAL_OUTLOOK_BY_ID.pending:
        {
            return {
                ...state,
                nationalOutlookVideoIsLoading: true,
                lastError: undefined,
            };
        }
        case GET_NATIONAL_OUTLOOK_BY_ID.fulfilled:
        {
            return {
                ...state,
                nationalOutlookVideo: action.payload,
                nationalOutlookVideoIsLoading: false
            };
        }

        case GET_NATIONAL_OUTLOOK_BY_ID.rejected:
        {
            return {
                ...state,
                nationalOutlookVideo: {},
                lastError: action.payload,
                nationalOutlookVideoIsLoading: false
            };
        }
    }

    return state;
}
